module.exports = __webpack_public_path__ + "img/case1.b6afce25.png";